module.exports = __webpack_public_path__ + "img/boiler-plant-sm.21a5462e.svg";